export const MenuRules = [
  {
    isSubmitted: false,
    hasElitCaseNo: false,
    SOAStatus: [0, 2],
    hasGrantSucceed: false,

    condition: (i) => {
      if ((i > 1) & (i <= 6)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).slice(1),
          },
          {
            disabled: true,
            completed: true,
            ids: [1],
          },
        ];
      } else if (i === 1) {
        return [
          {
            disabled: true,
            ids: Array.from({ length: i }, (_, k) => k + 1).slice(1),
          },
        ];
      }
    },
  },
  {
    isSubmitted: true,
    hasElitCaseNo: false,
    SOAStatus: [0, 2],
    hasGrantSucceed: false,

    condition: (i) => {
      const dIds = [1, 2, 3];
      if ((i > 3) & (i <= 6)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === o)
            ),
          },
          {
            disabled: true,
            ids: dIds,
          },
        ];
      } else if (i === 3) {
        // document rejection
        return [
          {
            disabled: true,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === i)
            ),
          },
        ];
      }
    },
  },
  {
    isSubmitted: true,
    hasElitCaseNo: true,
    SOAStatus: [0, 2],
    hasGrantSucceed: false,

    condition: (i) => {
      const dIds = [1, 2, 3];
      if ((i > 3) & (i <= 9)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === o)
            ),
          },
          {
            disabled: true,
            ids: dIds,
          },
        ];
      }
    },
  },
  {
    isSubmitted: false,
    hasElitCaseNo: false,
    SOAStatus: [1],
    hasGrantSucceed: false,

    condition: (i) => {
      const dIds = [1, 2, 3];
      if ((i > 3) & (i <= 8)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === o)
            ),
          },
          {
            disabled: true,
            ids: dIds,
          },
        ];
      }
    },
  },
  {
    isSubmitted: true,
    hasElitCaseNo: true,
    SOAStatus: [1],
    hasGrantSucceed: false,

    condition: (i) => {
      const dIds = [1, 2, 3, 7, 8];
      if ((i > 3) & (i <= 8)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === o)
            ),
          },
          {
            disabled: true,
            ids: dIds,
          },
        ];
      }
    },
  },
  {
    isSubmitted: true,
    hasElitCaseNo: false,
    SOAStatus: [1],
    hasGrantSucceed: false,

    condition: (i) => {
      const dIds = [1, 2, 3, 7, 8];
      if ((i > 3) & (i <= 8)) {
        return [
          {
            disabled: false,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === o)
            ),
          },
          {
            disabled: true,
            ids: dIds,
          },
        ];
      } else if (i === 3) {
        // document rejection
        return [
          {
            disabled: true,
            ids: Array.from({ length: i }, (_, k) => k + 1).filter(
              (o) => !dIds.some((x) => x === i)
            ),
          },
        ];
      }
    },
  },
  {
    isSubmitted: true,
    hasElitCaseNo: true,
    SOAStatus: [2],
    hasGrantSucceed: true,
    condition: (i) => {
      if (i === 9) {
        return [
          {
            disabled: true,
            completed: true,
            ids: Array.from({ length: i - 1 }, (_, k) => k + 1),
          },
        ];
      }
    },
  },
];

export const EnableDisableMenus = (props) => {
  const {
    isSubmitted,
    hasElitCaseNo,
    SOAStatus,
    hasPendingOAuth,
    hasGrantSucceed,
    hasLateSOA,
    menus,
    selectedMenu,
    completedMenuId,
    hasDocumentRejected,
    hasPendingMainSubmissionPayment,
    soaDisable,
  } = props;

  let rules = MenuRules.find(
    (o) =>
      o.isSubmitted === isSubmitted &&
      o.hasElitCaseNo === hasElitCaseNo &&
      o.SOAStatus.some((x) => x === SOAStatus) &&
      o.hasGrantSucceed === hasGrantSucceed
  );
  const passedMenuId =
    completedMenuId === 0 ? selectedMenu.id : completedMenuId;
  debugger;
  if (rules) {
    let newMenu = [...menus];
    const matchedIds = rules.condition(selectedMenu.id);
    debugger;
    if (matchedIds) {
      const disabledMenu = matchedIds.find((o) => o.disabled).ids;
      const enabledMenu = matchedIds.find((o) => !o.disabled)?.ids;
      newMenu = newMenu.map((x) =>
        disabledMenu.some((o) => o === x.id) ? { ...x, disabled: true } : x
      );
      if (enabledMenu)
        newMenu = newMenu.map((x) =>
          enabledMenu.some((o) => o === x.id || o > passedMenuId)
            ? { ...x, disabled: false }
            : x
        );

      newMenu = newMenu.map((x) =>
        x.id <= passedMenuId ? { ...x, completed: true } : x
      );
      if (hasLateSOA && SOAStatus === 0) {
        newMenu = newMenu.map((x) =>
          [5, 7].some((y) => y === x.id)
            ? { ...x, disabled: false, completed: false }
            : x
        );
      }

      if (passedMenuId >= 6 && hasPendingOAuth) {
        newMenu = newMenu.map((x) =>
          [7].some((y) => y === x.id)
            ? { ...x, disabled: SOAStatus === 1, completed: false }
            : x
        );
      }

      // if (SOAStatus === 1)
      //   newMenu = newMenu.map((x) =>
      //     selectedMenu <= passedMenuId && selectedMenu === 5 //SOA
      //       ? { ...x, disabled: true, completed: true }
      //       : x
      //   );
      if (hasDocumentRejected) {
        if (selectedMenu.id === 3) {
          newMenu = newMenu.map((x) =>
            x.id <= passedMenuId && x !== 3 ? { ...x, disabled: true } : x
          );
        } else if (selectedMenu.id > 3 && passedMenuId <= 6) {
          newMenu = newMenu.map((x) =>
            x.id > selectedMenu.id && x.id <= passedMenuId
              ? { ...x, disabled: false }
              : x
          );
        }
      }

      // If hasPendingMainSubmissionPayment and completedMenuId is 6, disable steps before 6
      if (hasPendingMainSubmissionPayment && passedMenuId === 6) {
        newMenu = newMenu.map((x) =>
          x.id < passedMenuId ? { ...x, disabled: true } : x
        );
      }

      if (soaDisable && passedMenuId >= 7) {
        newMenu = newMenu.map((x) =>
          x.id === 5 ? { ...x, disabled: true } : x
        );
      }

      newMenu = newMenu.map((x) =>
        x.id > passedMenuId ? { ...x, disabled: true } : x
      );

      if (
        selectedMenu.id === 3 &&
        hasDocumentRejected &&
        newMenu[selectedMenu.id - 1].disabled &&
        newMenu[selectedMenu.id - 1].completed
      ) {
        newMenu = newMenu.map((x) =>
          x.id === selectedMenu.id ? { ...x, navbtnenable: true } : x
        );
      }

      return newMenu;
    } else if (
      window.location.href ===
      window.location.origin + "/probate/steps/verification?q=e&from=step3"
    ) {
      let newMenu = [...menus];
      newMenu = newMenu.map((x) =>
        (x.id === selectedMenu.id) === 2
          ? { ...x, disabled: false }
          : { ...x, disabled: true }
      );
      return newMenu;
      //newMenu = newMenu
    }
  }
  return menus;
};
